import { FC } from 'react';

import Color from 'src/constants/color';

const STROKE_WIDTH = 1;
const DASH = '3 3';
const TOP_PADDING = 15;

interface VerticalLineProps {
    height: number;
    x: number;
}

const VerticalLine: FC<VerticalLineProps> = ({ height, x }) => {
    return (
        <g>
            <line
                x1={x}
                x2={x}
                y1={-TOP_PADDING}
                y2={height}
                stroke={Color.NormalGray}
                strokeWidth={STROKE_WIDTH}
                strokeDasharray={DASH}
            />
        </g>
    );
};

export default VerticalLine;
